import React, { useEffect } from 'react';
import { Modal, Icon, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { fetchHomologousProcedure, fetchHomologousProcedureFilter, homologousProcedureClear, homologousProcedureFilterClear } from 'app/actions/HomologousProcedureActions';
import { getHomologousProcedure, getHomologousProcedureFilter, getIsLoadingHomologousProcedure } from 'app/reducers';
import IconButton from '@material-ui/core/IconButton';
import ApiService from 'app/services/ApiService';
import { setTimeout } from 'timers';
import isEmpty from 'app/utils/IsEmpty';

export default function HomologousProcedureTableContainer(props) {
    const { classes } = props;
    const { confirm } = Modal;

    const { siteId } = useSelector(state => state.Auth);

    const pagination = props.pagination;
    const sorter = props.sorter;
    let offset = 0;
    let limit = 0;
    let column = null;
    let order = null;

    const columns = [
        {
            title: 'Nombre',
            dataIndex: 'procedureName',
            key: 'procedureName',
            sorter: true,
            width: 300,
            ellipsis: true

        },
        {
            title: 'Código',
            dataIndex: 'procedureCode',
            key: 'procedureCode',
            sorter: true,
            width: 300,
            ellipsis: true

        },
        {
            title: 'Compañía',
            dataIndex: 'clientName',
            key: 'clientName',
            sorter: true,
            width: 300,
            ellipsis: true

        },
        {

        },
        {
            title: 'Acciones',
            key: 'action',
            dataIndex: 'idProcedure',
            fixed: 'right',
            width: 120,
            render: (text, record) => (
                <div className={classes.buttons}>
                    {
                        siteId === 'HUB' ?
                            <Tooltip placement="bottomLeft" title={'Eliminar'}>
                                <IconButton className={classes.deleteIcon} onClick={() => showConfirmDelete(record)}>
                                    <Icon type="delete" />
                                </IconButton>
                            </Tooltip>
                            :
                            null
                    }

                    <Tooltip placement="bottomLeft" title={siteId === 'HUB' ? 'Editar' : 'Visualizar'}>
                        <IconButton className={classes.editIcon} onClick={() => showEdit(record)}>
                            {
                                siteId === 'HUB' ?
                                    <Icon type="edit" />
                                    :
                                    <Icon type="eye" />
                            }
                        </IconButton>
                    </Tooltip>
                </div>
            )
        }
    ];

    const showEdit = (param) => {
        props.isVisibleForm(true);
        props.setIdProcedure(param.idProcedure);
        props.setNameProcedure(param.procedureName);
        props.setCodeProcedure(param.procedureCode);
        props.setIdClient(String(param.idClient));
    }

    const showConfirmDelete = (param) => {
        confirm({
            title: '¿Eliminar Procedimiento Homólogo?',
            content: param.ProcedureName,
            okText: 'Eliminar',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk() {
                props.setFiltroNombre(props.FiltroNombre.filter(x => x !== param.procedureName));
                props.setFiltroCompany(props.FiltroCompany.filter(x => x !== param.clientName));
                props.setFiltroCodigo(props.FiltroCodigo.filter(x => x !== param.procedureCode));
                return deleteProcedure(param);
            },
            onCancel() { },
        });

    }

    async function deleteProcedure(param) {
        await ApiService.deleteProcedure(param.idProcedure).then(res => {
            dispatch(homologousProcedureClear());
            dispatch(homologousProcedureFilterClear());
            dispatch(fetchHomologousProcedureFilter({ IdProcedureType: '2' }))

            dispatch(fetchHomologousProcedure({
                ProcedureName: props.FiltroNombre.filter(x => x !== param.procedureName).join(','),
                ProcedureCode: props.FiltroCodigo.filter(x => x !== param.procedureCode).join(','),
                ClientName: props.FiltroCompany.filter(x => x !== param.clientName).join(','),
                sortColumn: column,
                IdProcedureType: '2',
                sortDir: order, offset: offset, limit: limit
            }));

            const modal = Modal.success({
                title: `Eliminado Correctamente`,
                content: '',
            });

            setTimeout(function () {
                modal.destroy();
            }, 3000)

        });
    }

    let homologousProcedure = useSelector(getHomologousProcedure);
    let homologousProcedureFilter = useSelector(getHomologousProcedureFilter);

    let isLoading = useSelector(getIsLoadingHomologousProcedure);
    const dispatch = useDispatch();

    useEffect(() => {
        if (isEmpty(homologousProcedure)) fetchHomologousProcedureAction();
        if (isEmpty(homologousProcedureFilter)) fetchHomologousProcedureFilterAction();
    }, []);

    const handleTableChange = (pagination, filters, sorter) => {

        props.setPagination(pagination);
        props.setSorter(sorter);
        if (Object.keys(sorter).length > 0) {
            column = sorter.field;
            order = sorter.order === "ascend" ? "ASC" : "DESC";
        }
        else {
            column = '';
            order = '';
        }

        dispatch(fetchHomologousProcedure(
            {
                ProcedureName: props.FiltroNombre.join('|'),
                ProcedureCode: props.FiltroCodigo.join('|'),
                ClientName: props.FiltroCompany.join('|'),
                CommunicationProgramName: (typeof props.formData.CommunicationProgramName === "undefined") ? '' : props.formData.CommunicationProgramName,
                CommunicationProgramDescription: (typeof props.formData.CommunicationProgramDescription === "undefined") ? '' : props.formData.CommunicationProgramDescription,
                IdProcedureType: '2',
                sortColumn: column,
                sortDir: order,
                offset: ((pagination.current - 1) * pagination.pageSize),
                limit: pagination.pageSize
            }));
    };

    //Load
    if (pagination != null) {
        offset = (0 * pagination.pageSize);
        limit = (pagination.pageSize);

        if (!isLoading && homologousProcedure.length > 0) {
            pagination.total = homologousProcedure[0].totalcount;
        }
        else {
            pagination.total = 0;
        }
    }

    if (sorter != null) {
        column = sorter.field;
        order = sorter.order === "ascend" ? "ASC" : "DESC";
    }



    const fetchHomologousProcedureAction = () => dispatch(fetchHomologousProcedure({
        ProcedureName: props.FiltroNombre !== undefined ? props.FiltroNombre.join(',') : '',
        ProcedureCode: props.FiltroCodigo !== undefined ? props.FiltroCodigo.join(',') : '',
        ClientName: props.FiltroCompany !== undefined ? props.FiltroCompany.join(',') : '',
        sortColumn: column,
        IdProcedureType: '2',
        sortDir: order, offset: offset, limit: limit
    }));
    const fetchHomologousProcedureFilterAction = () => dispatch(fetchHomologousProcedureFilter({ IdProcedureType: '2' }))
    return (props.children({ pagination: pagination, cols: columns, homologousProcedure, homologousProcedureFilter, isLoading, handleTableChange: handleTableChange }));
}

